/* eslint-disable import/order */
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { getGlobalPermissionPageResources } from '@jira/router-resources__advanced-roadmaps-settings/src/getGlobalPermissionPageResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { arjSettingsPermissionsRouteLegacyRedirectRoute } from '@jira/router-routes__advanced-roadmaps-settings-routes/src/arjSettingsPermissionsRouteLegacyRedirectRoute.tsx';
import { LazyArjSettingsPermissions } from './ui/index.tsx';
import { redirectTo } from './ui/redirect.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const arjSettingsPermissionsRouteLegacyRedirectRouteEntry: Route = createEntry(
	arjSettingsPermissionsRouteLegacyRedirectRoute,

	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: redirectTo('/jira/plans/settings/permissions'),
		isRedirect: true,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			...getGlobalPermissionPageResources(),
		],

		forPaint: [LazyAtlassianNavigation, LazyArjSettingsPermissions],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
